import React, { Component } from "react";
import Calendarizo from "../Calendarizo";
import { Accessor, ZTime } from "IZOX/STATIC";
import { VStack } from "IZOX/_X";

/**
 * @augments {Component<Props, State>}
 */
class Test extends Component {

  static propTypes = {

  };

  static defaultProps = {

  };

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Test.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  };

  onConfirm = (date) => {
    console.log(date);
  };

  onCancel = () => {
   
  };

  render(){
    return (
      <VStack height={"fit-content"} justifyContent={"center"} style={{overflow: "auto"}}>
        <Calendarizo
          onConfirm={this.onConfirm}
          onCancel={this.onCancel}
          selectType="date"
          valDate={ZTime.Now().add(1, "day").toISOString()}
          directConfirm
          />
        <Calendarizo
          onConfirm={this.onConfirm}
          onCancel={this.onCancel}
          selectType="date"
          directConfirm
          range
          maxRange={2}
          />
        <Calendarizo
          onConfirm={this.onConfirm}
          onCancel={this.onCancel}
          selectType="date"
          directConfirm
          size={30}
          />
        <Calendarizo
          onConfirm={this.onConfirm}
          onCancel={this.onCancel}
          selectType="date"
          directConfirm
          range
          size={25}
          />
        <Calendarizo
          onConfirm={this.onConfirm}
          onCancel={this.onCancel}
          selectType="date"
          directConfirm
          range
          size={20}
          />
        <Calendarizo
          onConfirm={this.onConfirm}
          onCancel={this.onCancel}
          selectType="date"
          directConfirm
          range
          size={15}
          />
      </VStack>
    );
  }

}

export default Test;
